module.exports = __webpack_public_path__ + "img/paint-pour.77c5a10c.svg";